var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 609,
    height: 295,
    viewBox: "0 0 609 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_808_10",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -9,
    width: 616,
    height: 304
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -9,
    width: 616,
    height: 304,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_808_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.998 341.305L387.956 443.629C397.955 449.41 414.181 449.421 424.18 443.629L601.137 341.316C611.136 335.535 611.136 326.164 601.137 320.383L424.341 218.272C414.331 212.492 398.104 212.492 388.094 218.272L211.02 320.394C201 326.153 201 335.524 210.998 341.305Z",
    fill: "url(#paint0_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8906 277.972C25.8906 277.972 27.3328 340.236 28.0271 398.718C28.0271 398.718 29.512 304.494 30.1637 277.972H25.8906Z",
    fill: "url(#paint1_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4454 275.238C45.676 268.385 44.3622 258.588 37.511 253.356C30.6597 248.124 20.8655 249.438 15.6349 256.291C10.4043 263.144 11.7181 272.941 18.5693 278.173C25.4206 283.405 35.2148 282.091 40.4454 275.238Z",
    fill: "url(#paint2_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.432 254.315C597.432 254.315 598.254 312.721 598.628 367.581C598.628 367.581 599.472 279.19 599.825 254.315H597.432Z",
    fill: "url(#paint3_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.508 248.752C608.273 243.92 604.977 239.382 600.147 238.617C595.316 237.852 590.779 241.149 590.014 245.981C589.249 250.813 592.545 255.35 597.376 256.116C602.207 256.881 606.743 253.584 607.508 248.752Z",
    fill: "url(#paint4_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.188 135.065C377.188 135.065 378.63 197.97 379.324 257.061C379.324 257.061 380.809 161.874 381.461 135.065H377.188Z",
    fill: "url(#paint5_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.023 131.767C396.997 124.725 395.321 114.984 388.281 110.009C381.241 105.034 371.502 106.709 366.529 113.751C361.555 120.793 363.231 130.535 370.271 135.51C377.311 140.485 387.05 138.809 392.023 131.767Z",
    fill: "url(#paint6_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5391 162.27L97.6245 363.146L306.33 242.614L306.288 41.7268L97.5391 162.27Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5391 182.273L306.288 61.7301V41.7268L97.5391 162.27V182.273Z",
    fill: "url(#paint7_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.429 93.9254V214.479L338.026 174.28L337.951 53.7801L268.429 93.9254Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.727 131.635C291.419 131.637 291.134 131.474 290.98 131.207C290.863 131.009 290.83 130.772 290.888 130.55C290.947 130.327 291.091 130.137 291.289 130.021L320.218 113.32C320.487 113.129 320.84 113.108 321.129 113.265C321.419 113.421 321.594 113.729 321.582 114.058C321.57 114.387 321.373 114.681 321.072 114.816L292.155 131.517C292.026 131.595 291.878 131.636 291.727 131.635Z",
    fill: "#B4CBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.538 144.158C284.229 144.154 283.944 143.988 283.79 143.72C283.556 143.306 283.699 142.782 284.11 142.544L327.482 117.487C327.895 117.253 328.419 117.396 328.657 117.807C328.773 118.006 328.806 118.242 328.748 118.465C328.69 118.687 328.546 118.878 328.347 118.994L284.976 144.04C284.842 144.115 284.691 144.155 284.538 144.158Z",
    fill: "#B4CBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.548 152.567C284.236 152.565 283.948 152.399 283.79 152.129C283.555 151.713 283.698 151.185 284.11 150.943L327.588 125.832C327.997 125.648 328.479 125.803 328.705 126.191C328.93 126.579 328.826 127.074 328.464 127.339L284.975 152.45C284.845 152.523 284.698 152.564 284.548 152.567Z",
    fill: "#B4CBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.549 160.934C284.157 160.935 283.814 160.673 283.711 160.295C283.608 159.917 283.772 159.518 284.111 159.321L327.599 134.199C328.015 133.96 328.546 134.104 328.785 134.52C329.024 134.936 328.881 135.467 328.465 135.706L284.976 160.817C284.847 160.895 284.699 160.935 284.549 160.934Z",
    fill: "#B4CBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.791 165.112C291.399 165.113 291.056 164.851 290.953 164.473C290.851 164.095 291.014 163.696 291.353 163.499L320.356 146.754C320.766 146.547 321.266 146.696 321.496 147.093C321.725 147.491 321.605 147.999 321.221 148.25L292.218 165.005C292.087 165.075 291.94 165.112 291.791 165.112Z",
    fill: "#B4CBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7461 232.901V353.444L132.343 313.245L132.268 192.745L62.7461 232.901Z",
    fill: "url(#paint8_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1082 270.61C85.7167 270.611 85.3731 270.349 85.2705 269.971C85.168 269.593 85.3319 269.193 85.6702 268.996L114.673 252.242C115.089 252.003 115.62 252.146 115.859 252.562C116.098 252.978 115.955 253.509 115.539 253.748L86.5355 270.492C86.408 270.573 86.2592 270.614 86.1082 270.61Z",
    fill: "url(#paint9_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8655 283.165C78.5532 283.163 78.2651 282.997 78.107 282.727C77.8724 282.311 78.015 281.783 78.4275 281.541L121.874 256.452C122.142 256.276 122.485 256.262 122.766 256.417C123.047 256.572 123.219 256.87 123.214 257.191C123.208 257.511 123.025 257.803 122.739 257.948L79.2501 283.069C79.1304 283.129 78.9992 283.162 78.8655 283.165Z",
    fill: "url(#paint10_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8655 291.532C78.5532 291.53 78.2651 291.363 78.107 291.094C77.8724 290.677 78.015 290.15 78.4275 289.908L121.906 264.797C122.315 264.613 122.797 264.768 123.022 265.156C123.248 265.543 123.144 266.039 122.782 266.304L79.2928 291.415C79.1621 291.488 79.0154 291.528 78.8655 291.532Z",
    fill: "url(#paint11_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.866 299.899C78.4745 299.9 78.131 299.638 78.0284 299.26C77.9258 298.882 78.0897 298.482 78.4281 298.285L121.917 273.164C122.186 273.009 122.517 273.01 122.785 273.166C123.054 273.321 123.219 273.609 123.218 273.919C123.217 274.229 123.051 274.516 122.782 274.67L79.2933 299.781C79.1646 299.859 79.0166 299.9 78.866 299.899Z",
    fill: "url(#paint12_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1087 304.087C85.7963 304.085 85.5082 303.919 85.3502 303.649C85.1156 303.233 85.2582 302.705 85.6707 302.463L114.674 285.719C115.09 285.48 115.621 285.624 115.86 286.04C116.099 286.456 115.955 286.987 115.539 287.226L86.536 303.97C86.4063 304.046 86.259 304.087 86.1087 304.087Z",
    fill: "url(#paint13_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 268.89V275.889C193.062 276.836 193.566 277.711 194.386 278.185C195.206 278.659 196.216 278.659 197.036 278.186L241.551 252.477C243.261 251.484 244.315 249.657 244.318 247.679V240.723C244.322 239.764 243.812 238.877 242.982 238.397C242.152 237.918 241.129 237.921 240.301 238.404L195.851 264.049C194.122 265.047 193.059 266.893 193.063 268.89Z",
    fill: "url(#paint14_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.467 269.178C536.048 308.928 526.434 347.118 526.071 348.561L507.975 338.014L506.682 322.798L501.223 334.082L459.305 309.655L459.785 294.214L451.538 305.135L433.068 294.364L434.863 280.772L426.701 290.688L389.451 268.975C389.451 268.975 404.791 245.862 413.53 225.368C416.722 217.604 419.37 209.627 421.456 201.496L539.467 269.178Z",
    fill: "url(#paint15_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.161 319.635C568.666 322.696 561.376 326.237 554.337 330.235L551.281 318.93L550.213 332.66C537.394 340.311 526.092 348.603 526.092 348.603C526.455 347.161 536.069 308.971 539.488 269.221L550.534 262.809L565.489 254.112C569.068 282.001 576.161 319.635 576.161 319.635Z",
    fill: "url(#paint16_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.717 226.201L540.665 241.855L427.141 175.723L451.711 161.511L563.717 226.201Z",
    fill: "url(#paint17_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.631 241.855C540.684 250.756 540.225 260.021 539.424 269.178L421.402 201.539C425.12 187.648 427.096 175.733 427.096 175.733L540.631 241.855Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.448 254.058L539.479 269.178C540.28 260.01 540.739 250.756 540.686 241.855L563.728 226.201C562.863 230.304 563.792 241.139 565.448 254.058Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.926 204.606L501.459 211.818L489.025 204.638C489.025 204.638 476.601 53.7587 501.459 68.0345C526.371 82.4171 513.926 204.606 513.926 204.606Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.575 164.717C516.425 168.628 516.254 172.389 516.041 175.926C515.143 192.723 513.904 204.606 513.904 204.606L501.438 211.818V68.0345C516.97 76.9889 518.006 127.692 516.575 164.717Z",
    fill: "url(#paint18_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.758 100.764C495.82 101.362 494.612 101.323 493.713 100.668C491.697 99.4859 490.473 97.31 490.509 94.9726C490.701 93.0172 492.357 92.2585 494.237 93.2095C493.701 93.6444 493.372 94.2838 493.329 94.9726C493.3 97.3083 494.522 99.4811 496.534 100.668C496.605 100.707 496.68 100.739 496.758 100.764Z",
    fill: "url(#paint19_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.656 99.0117C497.628 99.699 497.3 100.339 496.759 100.764C496.685 100.739 496.613 100.706 496.545 100.668C494.534 99.481 493.311 97.3083 493.34 94.9726C493.383 94.2837 493.713 93.6443 494.248 93.2095L494.462 93.3163C496.474 94.5011 497.694 96.6765 497.656 99.0117Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.779 225.058C488.74 225.992 488.295 226.862 487.561 227.441C486.493 228.221 485.04 228.221 483.427 227.302C480.767 225.774 478.823 222.311 479.154 219.565C479.485 216.819 481.654 215.89 484.207 217.172L484.495 217.321C487.134 218.839 489.067 222.258 488.779 225.058Z",
    fill: "url(#paint20_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.709 62.6704C179.832 65.3691 181.123 67.8809 183.245 69.5518C186.172 71.8171 190.552 71.8172 195.209 69.1671C202.933 64.7434 208.552 54.7097 207.697 46.7276C206.928 39.0341 200.433 36.0421 193.052 39.8034C192.785 39.921 192.475 40.0813 192.208 40.2309C184.473 44.6226 178.865 54.6669 179.709 62.6704Z",
    fill: "url(#paint21_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.528 63.5787L187.037 55.5645C186.811 55.211 186.9 54.7417 187.24 54.496C187.596 54.2799 188.057 54.3676 188.309 54.699L192.293 60.5226L200.145 44.6653C200.361 44.3245 200.8 44.2014 201.162 44.3798C201.524 44.5581 201.693 44.9806 201.555 45.3599L192.528 63.5787Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.467 269.178C536.048 308.928 526.434 347.118 526.071 348.561C489.077 260.651 422.45 202.415 421.467 201.507L539.467 269.178Z",
    fill: "url(#paint22_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.337 330.235C561.943 284.351 550.523 262.756 550.523 262.756L565.479 254.058C569.1 282.001 576.162 319.635 576.162 319.635C568.667 322.696 561.377 326.237 554.337 330.235Z",
    fill: "url(#paint23_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 244.698C368.813 244.698 365.779 244.879 354.488 250.746C343.378 256.537 331.948 265.887 331.595 266.186L294.366 244.698C294.772 244.388 308.072 234.472 317.238 229.257C326.852 223.797 331.584 223.209 331.584 223.209L368.813 244.698Z",
    fill: "url(#paint24_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 244.698L331.595 266.186C331.947 265.887 343.346 256.569 354.488 250.746C365.779 244.847 368.813 244.698 368.813 244.698Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 244.666V251.825L331.595 273.356L331.605 266.154L368.813 244.666Z",
    fill: "url(#paint25_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.595 273.356L294.366 251.793V244.666L331.606 266.154L331.595 273.356Z",
    fill: "url(#paint26_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.366 251.793L300.573 319.891L331.595 337.811V273.356L294.366 251.793Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 251.825L362.606 319.902L331.595 337.811V273.356L368.813 251.825Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.598 304.6C319.073 304.596 318.59 304.316 318.326 303.863L304.695 279.799C304.5 279.465 304.448 279.065 304.55 278.691C304.653 278.317 304.902 278 305.24 277.812C305.577 277.619 305.977 277.568 306.352 277.67C306.727 277.773 307.045 278.019 307.238 278.357L320.869 302.421C321.064 302.755 321.116 303.155 321.014 303.529C320.911 303.903 320.663 304.22 320.324 304.408C320.103 304.534 319.852 304.6 319.598 304.6Z",
    fill: "url(#paint27_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.967 296.747C305.301 296.752 304.715 296.307 304.542 295.664C304.368 295.02 304.651 294.341 305.23 294.011L319.256 285.933C319.71 285.644 320.285 285.627 320.755 285.889C321.225 286.151 321.513 286.65 321.506 287.188C321.498 287.726 321.196 288.216 320.72 288.465L306.693 296.544C306.474 296.676 306.223 296.746 305.967 296.747Z",
    fill: "url(#paint28_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.004 304.6C342.749 304.599 342.5 304.533 342.278 304.408C341.582 304.007 341.338 303.12 341.733 302.421L355.374 278.357C355.793 277.701 356.653 277.487 357.33 277.872C358.007 278.256 358.265 279.103 357.917 279.799L344.275 303.863C344.013 304.318 343.529 304.598 343.004 304.6Z",
    fill: "url(#paint29_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.635 296.747C356.379 296.746 356.128 296.676 355.908 296.544L341.936 288.508C341.459 288.259 341.157 287.769 341.15 287.231C341.142 286.693 341.43 286.194 341.9 285.932C342.37 285.67 342.945 285.687 343.399 285.976L357.425 294.054C358.004 294.384 358.287 295.063 358.113 295.706C357.94 296.35 357.354 296.795 356.688 296.789L356.635 296.747Z",
    fill: "url(#paint30_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.655 179.516C230.199 177.845 229.478 176.257 228.518 174.815L233.507 165.946L224.299 161.03L219.353 169.824C217.568 169.773 215.786 170.008 214.075 170.519L214.011 162.409L201.096 170.305L201.16 178.416C199.274 180.195 197.525 182.113 195.926 184.154L190.883 181.472L181.846 197.5L186.92 200.214C186.045 202.595 185.349 205.038 184.837 207.523L177.69 211.904L177.808 226.746L185.051 222.322C185.528 223.952 186.267 225.493 187.241 226.885L182.156 235.936L191.364 240.862L196.492 231.736C198.216 231.762 199.935 231.524 201.587 231.031L201.651 239.472L214.556 231.576L214.492 223.134C215.56 222.183 216.5 221.157 217.462 220.1L208.478 215.27L207.944 215.601C200.882 219.875 195.124 216.841 195.028 208.698C194.932 200.556 200.637 190.469 207.709 186.141C214.78 181.814 220.528 184.912 220.634 193.033C220.637 193.651 220.609 194.268 220.549 194.882L229.49 199.049C229.987 197.512 230.4 195.95 230.73 194.369L237.972 189.945L237.855 175.103L230.655 179.516Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.543 204.018C210.977 205.012 210.058 205.578 209.492 205.268C208.926 204.958 208.905 203.911 209.492 202.907C210.08 201.902 210.966 201.347 211.543 201.656C212.12 201.966 212.099 203.024 211.543 204.018Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.486 200.075C216.896 195.438 216.244 191.27 213.541 189.828C211.818 189.053 209.826 189.165 208.2 190.127L209.546 198.216L205.743 204.99L198.383 206.518C198.383 209.072 199.323 211.102 201.043 212.021C203.457 213.304 206.875 212.085 209.899 209.2C211.374 207.762 212.633 206.117 213.638 204.317C214.408 202.976 215.028 201.553 215.486 200.075ZM209.493 205.268C208.916 204.969 208.905 203.911 209.493 202.907C210.08 201.902 210.967 201.347 211.544 201.656C212.121 201.966 212.121 203.014 211.544 204.018C210.967 205.022 210.059 205.578 209.471 205.268H209.493Z",
    fill: "url(#paint31_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.588 217.524L239.96 222.205C239.244 223.487 238.069 224.203 237.332 223.807L209.963 209.2C211.438 207.762 212.697 206.117 213.702 204.317C214.468 202.965 215.08 201.531 215.529 200.043L242.566 214.479C243.261 214.896 243.271 216.253 242.588 217.524Z",
    fill: "url(#paint32_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.691 216.231L217.098 208.442C216.746 208.26 216.735 207.598 217.098 206.978C217.451 206.358 218.017 206.005 218.38 206.198L232.973 213.988C233.325 214.18 233.336 214.832 232.973 215.451C232.62 216.082 232.054 216.424 231.691 216.231Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.756 217.685C85.756 217.207 85.3686 216.819 84.8907 216.819C84.4128 216.819 84.0254 217.207 84.0254 217.685V222.889C84.0254 223.367 84.4128 223.754 84.8907 223.754C85.3686 223.754 85.756 223.367 85.756 222.889V217.685Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8907 208.367C84.4128 208.367 84.0254 207.979 84.0254 207.501V197.329C84.0312 196.849 84.4217 196.463 84.9014 196.463C85.3792 196.463 85.7666 196.851 85.7666 197.329V207.501C85.7667 207.733 85.674 207.955 85.5094 208.117C85.3449 208.28 85.122 208.37 84.8907 208.367ZM84.8907 188.065C84.4128 188.065 84.0254 187.677 84.0254 187.199V177.016C84.0312 176.54 84.4152 176.156 84.8907 176.15C85.3703 176.156 85.756 176.547 85.756 177.026V187.199C85.756 187.673 85.3751 188.059 84.9014 188.065H84.8907ZM84.8907 167.762C84.4111 167.756 84.0254 167.366 84.0254 166.886V156.713C84.0254 156.235 84.4128 155.848 84.8907 155.848C85.3686 155.848 85.756 156.235 85.756 156.713V166.886C85.7183 167.328 85.3557 167.673 84.912 167.687L84.8907 167.762ZM84.8907 147.46C84.4128 147.46 84.0254 147.072 84.0254 146.594V136.422C84.0254 135.944 84.4128 135.556 84.8907 135.556C85.3686 135.556 85.756 135.944 85.756 136.422V146.594C85.6891 147.011 85.3343 147.321 84.912 147.331L84.8907 147.46Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9229 126.986C84.445 126.986 84.0576 126.599 84.0576 126.121V120.415L88.993 117.562C89.262 117.407 89.5931 117.408 89.8615 117.564C90.1299 117.719 90.2948 118.007 90.2942 118.317C90.2935 118.627 90.1273 118.914 89.8583 119.068L85.7989 121.419V126.121C85.7989 126.352 85.7063 126.574 85.5417 126.737C85.3771 126.899 85.1542 126.989 84.9229 126.986Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2336 114.089C97.9255 114.092 97.6398 113.928 97.4858 113.661C97.3701 113.462 97.3389 113.224 97.3991 113.002C97.4593 112.779 97.6058 112.59 97.8062 112.475L106.609 107.389C106.877 107.213 107.22 107.2 107.501 107.355C107.782 107.51 107.954 107.807 107.949 108.128C107.943 108.449 107.76 108.74 107.474 108.885L98.6715 113.982C98.5367 114.054 98.3862 114.09 98.2336 114.089ZM115.849 103.916C115.46 103.913 115.12 103.649 115.021 103.272C114.921 102.896 115.085 102.499 115.422 102.303L124.224 97.2058C124.493 97.0512 124.824 97.0519 125.093 97.2077C125.361 97.3635 125.526 97.6507 125.525 97.9611C125.525 98.2714 125.359 98.5579 125.09 98.7125L116.287 103.799C116.153 103.874 116.003 103.914 115.849 103.916ZM133.465 93.7331C133.157 93.7358 132.871 93.5725 132.717 93.3056C132.601 93.1061 132.57 92.8685 132.63 92.6459C132.69 92.4232 132.837 92.2337 133.037 92.1196L141.84 87.0333C142.108 86.8572 142.452 86.844 142.732 86.9989C143.013 87.1539 143.186 87.4515 143.18 87.7723C143.174 88.0931 142.991 88.3844 142.705 88.5292L133.903 93.6155C133.771 93.695 133.619 93.7357 133.465 93.7331ZM151.08 83.5605C150.683 83.5655 150.334 83.2995 150.233 82.9153C150.132 82.5311 150.305 82.1274 150.653 81.9363L159.455 76.85C159.655 76.7343 159.892 76.7031 160.115 76.7633C160.338 76.8235 160.527 76.9701 160.641 77.1706C160.756 77.3685 160.787 77.6044 160.727 77.8254C160.667 78.0463 160.52 78.2339 160.321 78.346L151.518 83.4429C151.384 83.5177 151.234 83.5581 151.08 83.5605Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.695 73.3772C168.306 73.3736 167.967 73.1101 167.867 72.7334C167.767 72.3567 167.931 71.9598 168.268 71.7637L172.765 69.1565C173.034 69.0019 173.365 69.0026 173.634 69.1583C173.902 69.3141 174.067 69.6013 174.067 69.9117C174.066 70.2221 173.9 70.5085 173.631 70.6631L169.133 73.2597C169.001 73.3392 168.849 73.3799 168.695 73.3772Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.355 45.3065C217.045 45.3048 216.76 45.1377 216.607 44.8684C216.491 44.6717 216.458 44.4368 216.517 44.216C216.575 43.9952 216.719 43.8068 216.917 43.693L221.425 41.0857C221.841 40.8467 222.372 40.9902 222.611 41.4063C222.849 41.8223 222.706 42.3533 222.29 42.5924L217.793 45.1889C217.659 45.2637 217.508 45.3041 217.355 45.3065Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.677 37.6129C230.285 37.6141 229.942 37.3521 229.839 36.9742C229.736 36.5962 229.9 36.1965 230.239 35.9994L239.052 30.9131C239.32 30.7371 239.663 30.7239 239.944 30.8788C240.225 31.0337 240.397 31.3314 240.392 31.6522C240.386 31.973 240.203 32.2643 239.917 32.4091L231.104 37.4954C230.975 37.5734 230.827 37.6141 230.677 37.6129ZM248.303 27.4403C247.991 27.4381 247.702 27.2717 247.544 27.0022C247.31 26.5856 247.452 26.0578 247.865 25.8161L256.678 20.7298C257.094 20.4908 257.625 20.6344 257.864 21.0504C258.103 21.4665 257.959 21.9975 257.543 22.2365L248.73 27.3228C248.599 27.3963 248.453 27.4366 248.303 27.4403ZM265.929 17.2571C265.538 17.2583 265.194 16.9963 265.091 16.6183C264.989 16.2404 265.153 15.8406 265.491 15.6436L274.304 10.5466C274.573 10.392 274.904 10.3927 275.173 10.5485C275.441 10.7042 275.606 10.9914 275.605 11.3018C275.605 11.6122 275.439 11.8986 275.17 12.0532L266.356 17.1395C266.228 17.2176 266.08 17.2583 265.929 17.2571ZM283.555 7.07381C283.164 7.07499 282.82 6.81304 282.718 6.43508C282.615 6.05712 282.779 5.65735 283.117 5.46029L291.931 0.374003C292.199 0.19796 292.542 0.184749 292.823 0.339678C293.104 0.494607 293.276 0.792252 293.27 1.11305C293.265 1.43385 293.082 1.72516 292.796 1.86997L283.983 6.96695C283.851 7.0371 283.704 7.07381 283.555 7.07381Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.679 58.2893C305.199 58.2835 304.813 57.8929 304.813 57.4131V47.6252C304.813 47.316 304.978 47.0303 305.246 46.8757C305.514 46.721 305.844 46.721 306.111 46.8757C306.379 47.0303 306.544 47.316 306.544 47.6252V57.4131C306.544 57.8929 306.158 58.2835 305.679 58.2893ZM305.679 38.6922C305.201 38.6922 304.813 38.3046 304.813 37.8266V28.028C304.813 27.55 305.201 27.1625 305.679 27.1625C306.157 27.1625 306.544 27.55 306.544 28.028V37.8266C306.544 38.3046 306.157 38.6922 305.679 38.6922ZM305.679 19.095C305.201 19.095 304.813 18.7075 304.813 18.2295V8.43086C304.813 7.95285 305.201 7.56534 305.679 7.56534C306.157 7.56534 306.544 7.95285 306.544 8.43086V18.2295C306.544 18.7075 306.157 19.095 305.679 19.095Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.679 73.2811C305.201 73.2811 304.813 72.8936 304.813 72.4155V67.2117C304.813 66.7337 305.201 66.3462 305.679 66.3462C306.157 66.3462 306.544 66.7337 306.544 67.2117V72.4155C306.544 72.8936 306.157 73.2811 305.679 73.2811Z",
    fill: "#D4DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.813 244.698C326.35 230.208 295.018 244.388 294.377 244.698C294.783 244.388 308.083 234.472 317.248 229.257C326.863 223.797 331.595 223.209 331.595 223.209L368.813 244.698Z",
    fill: "url(#paint33_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.415 239.932V246.258L338.036 245.467V241.268C338.041 240.677 337.727 240.129 337.214 239.836L328.978 235.081C328.724 234.932 328.41 234.929 328.154 235.075C327.899 235.22 327.74 235.492 327.738 235.786V239.515L326.371 238.724V232.997C326.388 232.633 326.59 232.303 326.905 232.121C327.221 231.94 327.608 231.931 327.931 232.099L338.368 238.126C339.007 238.505 339.403 239.189 339.415 239.932Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.679 263.183C508.679 263.183 500.433 272.555 502.783 273.367C505.133 274.179 513.583 268.024 513.85 266.186C513.961 265.456 513.635 264.729 513.017 264.327L509.694 262.574L508.679 263.183Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.903 257.114C500.903 257.114 492.774 266.325 495.092 267.126C497.41 267.928 505.774 261.848 505.988 260.063C506.098 259.348 505.781 258.634 505.176 258.236L501.896 256.505L500.903 257.114Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.17 220.837C512.764 222.222 511.788 223.985 511.361 225.913C510.826 228.894 508.679 263.183 508.679 263.183C508.679 263.183 508.551 263.846 510.677 264.252C511.446 264.435 512.247 264.435 513.016 264.252C513.016 264.252 515.623 230.411 517.118 228.584C518.274 227.222 519.547 225.963 520.921 224.823C520.921 224.823 522.78 221.777 522.844 221.414C522.908 221.051 517.503 218.518 517.503 218.518L514.17 220.837Z",
    fill: "url(#paint34_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.309 215.419C504.922 216.779 503.961 218.513 503.542 220.409C503.008 223.348 500.904 257.114 500.904 257.114C500.904 257.114 500.776 257.755 502.859 258.183C503.617 258.378 504.41 258.396 505.177 258.236C505.177 258.236 507.73 224.908 509.204 223.113C510.344 221.774 511.599 220.537 512.954 219.416C512.954 219.416 514.781 216.402 514.845 216.05C514.909 215.697 509.503 213.207 509.503 213.207L506.309 215.419Z",
    fill: "url(#paint35_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.273 212.449C536.273 212.449 536.668 216.969 531.605 221.393C526.541 225.816 523.817 226.821 523.817 226.821C523.817 226.821 516.094 221.478 511.094 219.341C506.095 217.204 502.602 218.379 502.602 218.379C504.513 214.941 506.905 211.792 509.705 209.029C511.671 207.059 513.904 205.376 516.339 204.029C516.339 204.029 522.3 203.184 522.482 203.184C522.663 203.184 529.169 203.847 529.169 203.847L534.286 204.691L536.273 212.449Z",
    fill: "url(#paint36_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.202 179.452C547.202 179.452 541.55 182.433 540.033 184.196C538.517 185.959 538.709 187.819 537.619 189.667C536.001 192.696 535.647 196.242 536.636 199.53C537.908 203.708 536.273 212.449 536.273 212.449C536.273 212.449 529.949 207.982 526.584 207.106C523.219 206.23 523.443 206.753 519.897 205.845C516.35 204.937 516.34 203.975 516.34 203.975C516.34 203.975 517.483 196.378 518.262 192.467C519.042 188.556 516.724 186.536 518.957 183.267C519.769 182.07 517.461 181.13 515.752 180.606C515.912 177.988 516.115 175.146 516.222 172.261C518.786 173.265 522.995 174.611 524.02 174.505C525.655 174.344 529.81 176.439 529.81 176.439L532.855 176.022C534.557 176.57 536.387 176.57 538.089 176.022C540.813 175.082 544.958 173.083 544.958 173.083C544.949 173.804 545.035 174.523 545.215 175.221C545.335 175.705 545.481 176.183 545.653 176.652C545.922 177.432 546.28 178.178 546.721 178.875C546.945 179.174 547.084 179.345 547.127 179.388L547.202 179.452Z",
    fill: "url(#paint37_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.109 180.863C531.029 180.604 532.017 180.861 532.694 181.536C533.901 182.679 534.019 183.224 534.019 183.224L532.876 176.054L529.18 177.593L530.109 180.863Z",
    fill: "#B4CBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.881 180.585C528.351 180.433 527.794 180.393 527.247 180.467C526.719 180.571 526.228 180.814 525.826 181.172L528.443 176.535L529.512 177.144L530.089 178.64L528.881 180.585Z",
    fill: "#B4CBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.567 173.308L532.877 176.043C532.877 176.043 531.584 181.322 529.501 180.895C527.418 180.467 528.433 176.503 528.433 176.503C528.432 175.911 528.353 175.322 528.198 174.75C528.112 174.226 528.278 173.691 528.647 173.308C528.721 173.393 532.567 173.308 532.567 173.308Z",
    fill: "url(#paint38_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.608 165.443C524.017 167.212 523.932 169.111 524.362 170.925C525.024 174.302 526.499 175.509 526.499 175.509C526.499 175.509 532.075 176.107 533.656 171.171C534.526 168.034 534.004 164.675 532.225 161.949L527.588 162.248L524.608 165.443Z",
    fill: "url(#paint39_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.607 165.39C524.607 165.39 529.265 164.215 530.622 166.64C531.978 169.066 530.515 170.38 533.153 172.806C535.792 175.231 540.749 162.483 533.207 159.898C524.8 156.991 524.607 165.39 524.607 165.39Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.281 159.876C533.281 159.876 535.172 157.536 536.486 158.626C537.8 159.716 537.747 167.014 539.082 166.961C540.417 166.907 540.77 166.223 540.77 166.223C540.77 166.223 539.167 170.359 536.977 168.734C534.788 167.11 534.617 162.772 534.617 162.772L533.281 159.876Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.656 172.613C554.52 174.932 549.328 177.668 547.501 178.576L546.86 178.896H546.743C546.302 178.199 545.943 177.453 545.674 176.674C545.503 176.205 545.356 175.727 545.236 175.242C545.236 174.921 545.3 174.729 545.3 174.729C545.3 174.729 545.781 174.526 546.518 174.184C548.569 173.233 552.565 171.224 552.789 169.91C553.088 168.093 553.932 150.975 552.789 150.078C551.548 149.273 550.757 147.931 550.652 146.455C550.535 144.714 555.994 143.869 556.806 145.494C557.618 147.118 555.737 148.507 555.951 150.078C556.165 151.648 559.295 169.782 556.656 172.613Z",
    fill: "url(#paint40_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.517 174.173C545.78 174.515 545.3 174.718 545.3 174.718C545.3 174.718 545.3 174.911 545.236 175.231C545.056 174.533 544.97 173.815 544.979 173.094C544.979 173.094 545.706 173.105 546.517 174.173Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.543 178.576C547.475 178.884 547.359 179.179 547.201 179.452C547.201 179.452 547.019 179.238 546.795 178.939H546.912L547.543 178.576Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.98 165.123C485.98 165.123 485.489 171.534 487.465 171.32C489.441 171.107 490.424 169.835 490.242 167.805C490.061 165.775 488.416 163.05 487.166 163.103C485.916 163.157 485.98 165.123 485.98 165.123Z",
    fill: "url(#paint41_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.795 303.596C255.727 305.904 254.755 317.85 253.996 329.241C253.238 340.632 252.768 351.275 252.768 351.275C252.047 352.056 250.958 352.384 249.926 352.129C247.918 351.841 247.629 351.125 247.629 351.125L247.49 344.393L247.33 337.116L247.245 332.757L247.619 332.19C248.078 325.02 249.093 312.347 250.588 310.285C252.725 307.389 255.417 295.325 255.417 295.325H252.629C252.806 295.55 252.926 295.814 252.981 296.095C253.334 298.061 251.913 303.81 249.873 308.415C248.911 310.552 247.96 321.238 247.223 331.923L246.476 296.661V295.464L246.711 295.293L248.089 294.225L249.104 293.466H249.189L255.599 288.626C255.599 288.626 259.53 289.406 259.872 291.372C260.213 293.338 258.857 299.001 256.795 303.596Z",
    fill: "url(#paint42_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.873 308.33C248.912 310.467 247.961 321.152 247.224 331.838L247.16 332.789C247.074 334.039 246.989 335.289 246.914 336.518C246.754 339.061 246.615 341.54 246.476 343.816C246.081 350.762 245.846 355.923 245.846 355.923C245.13 356.705 244.044 357.033 243.015 356.778C240.996 356.5 240.718 355.784 240.718 355.784L240.398 340.824L240.269 334.723L240.13 328.311L239.682 306.876L239.532 300.123L246.059 295.229L248.698 293.252C248.698 293.252 248.912 293.252 249.157 293.37C250.329 293.636 251.425 294.166 252.362 294.919L252.629 295.229C252.806 295.454 252.927 295.718 252.982 295.999C253.334 297.975 251.935 303.724 249.873 308.33Z",
    fill: "url(#paint43_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.31 249.314C218.482 249.05 217.767 248.516 217.28 247.796C215.56 245.339 218.22 245.435 215.752 243.148C214.876 242.336 215.945 241.31 217.718 240.744C219.491 240.178 221.991 244.42 221.638 247.764C221.286 251.109 219.31 249.314 219.31 249.314Z",
    fill: "url(#paint44_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.138 235.765C241.355 235.545 240.67 235.066 240.194 234.407C238.506 232.164 240.995 232.164 238.624 230.133C237.78 229.407 238.741 228.402 240.386 227.825C242.031 227.248 244.51 231.127 244.264 234.237C244.018 237.346 242.138 235.765 242.138 235.765Z",
    fill: "url(#paint45_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.816 260.662C256.816 260.662 247.725 233.061 242.683 234.514C238.175 235.818 249.371 261.228 249.371 261.228L256.816 260.662Z",
    fill: "url(#paint46_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.62 255.501L250.983 260.095C250.983 260.095 248.847 262.232 248.783 262.232C248.719 262.232 244.958 261.858 244.958 261.858C244.993 259.947 244.918 258.034 244.734 256.131L244.488 255.426L249.958 254.047L250.62 255.501Z",
    fill: "url(#paint47_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.235 246.3C242.235 246.3 239.746 251.793 240.408 252.135C241.07 252.477 240.12 256.783 242.812 256.697C245.905 256.706 248.745 254.987 250.172 252.242C251.913 249.036 247.469 244.548 247.469 244.548L244.179 243.672L242.235 246.3Z",
    fill: "url(#paint48_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.384 238.596C242.384 238.596 238.581 243.672 242.234 246.3C245.888 248.929 245.546 249.998 244.98 251.066C244.639 251.629 244.561 252.311 244.766 252.936C244.766 252.936 247.896 249.175 248.281 251.483C248.665 253.791 245.012 254.421 247.212 255.437C249.413 256.452 254.412 255.073 255.32 250.478C256.228 245.884 253.184 244.163 253.184 244.163C253.184 244.163 253.43 241.385 251.432 240.37C249.434 239.355 247.8 240.53 246.956 240.049C246.112 239.569 247.373 237.079 245.578 236.309C244.563 235.882 242.384 238.596 242.384 238.596Z",
    fill: "#012860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.399 293.851C260.879 294.433 260.282 294.944 259.626 295.368C259.282 295.566 258.925 295.741 258.558 295.892C258.265 296.017 257.965 296.128 257.661 296.223L256.763 292.547L256.347 296.608C256.347 296.608 255.054 297.527 249.296 298.884C245.423 299.679 241.434 299.722 237.545 299.012C237.078 296.86 237.049 294.636 237.46 292.472C238.09 288.348 238.784 288.284 239.351 280.141C239.917 271.999 232.941 267.554 226.852 260.907C220.763 254.261 217.238 250.222 220.378 247.764C222.248 246.29 229.907 253.887 235.686 258.215H235.751C238.411 260.192 240.654 261.42 241.754 260.811L245.162 258.856C247.88 257.291 251.137 256.96 254.114 257.948L254.552 258.097C257.949 259.411 258.291 263.258 257.757 268.783C257.757 268.943 257.757 269.114 257.757 269.285C257.169 275.044 258.825 278.902 260.064 283.55C260.863 286.928 261.311 290.38 261.399 293.851Z",
    fill: "url(#paint49_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.732 260.94C240.664 261.869 239.596 265.128 238.089 266.207C236.583 267.287 238.089 264.573 238.388 262.617C238.677 260.875 236.252 258.749 235.729 258.343C238.388 260.32 240.632 261.581 241.732 260.94Z",
    fill: "url(#paint50_linear_808_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.399 293.851C260.878 294.433 260.282 294.944 259.626 295.368C259.282 295.566 258.925 295.741 258.557 295.892C258.227 295.121 258.13 294.27 258.28 293.445C258.739 289.598 255.075 291.169 252.361 289.897C249.648 288.626 256.229 284.554 256.752 281.701C257.382 278.903 255.775 276.085 253.045 275.205C250.075 273.976 257.746 268.793 257.746 268.793C257.746 268.954 257.746 269.125 257.746 269.296C257.158 275.055 258.814 278.913 260.053 283.561C260.855 286.935 261.306 290.384 261.399 293.851Z",
    fill: "url(#paint51_linear_808_10)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_808_10",
    x1: 203.499,
    y1: 330.951,
    x2: 608.637,
    y2: 330.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_808_10",
    x1: 25.8906,
    y1: 338.356,
    x2: 30.0996,
    y2: 338.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_808_10",
    x1: 43.7402,
    y1: 265.65,
    x2: 12.5256,
    y2: 265.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_808_10",
    x1: 597.432,
    y1: 310.905,
    x2: 599.825,
    y2: 310.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_808_10",
    x1: 607.713,
    y1: 247.224,
    x2: 589.99,
    y2: 247.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_808_10",
    x1: 377.145,
    y1: 196.057,
    x2: 381.364,
    y2: 196.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_808_10",
    x1: 394.917,
    y1: 122.705,
    x2: 363.702,
    y2: 122.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_808_10",
    x1: 97.5391,
    y1: 111.995,
    x2: 306.288,
    y2: 111.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_808_10",
    x1: 62.7461,
    y1: 273.1,
    x2: 132.343,
    y2: 273.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_808_10",
    x1: 85.2429,
    y1: 261.367,
    x2: 115.966,
    y2: 261.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_808_10",
    x1: 77.9895,
    y1: 269.734,
    x2: 123.209,
    y2: 269.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_808_10",
    x1: 77.9895,
    y1: 278.1,
    x2: 123.209,
    y2: 278.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_808_10",
    x1: 77.9901,
    y1: 286.478,
    x2: 123.209,
    y2: 286.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_808_10",
    x1: 85.2434,
    y1: 294.845,
    x2: 115.967,
    y2: 294.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_808_10",
    x1: 193.063,
    y1: 258.29,
    x2: 244.318,
    y2: 258.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_808_10",
    x1: 389.44,
    y1: 275.066,
    x2: 539.467,
    y2: 275.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_808_10",
    x1: 526.06,
    y1: 301.331,
    x2: 576.161,
    y2: 301.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_808_10",
    x1: 427.141,
    y1: 201.678,
    x2: 563.717,
    y2: 201.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_808_10",
    x1: 501.47,
    y1: 139.926,
    x2: 517.045,
    y2: 139.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_808_10",
    x1: 490.519,
    y1: 96.9922,
    x2: 496.758,
    y2: 96.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_808_10",
    x1: 479.09,
    y1: 222.312,
    x2: 488.811,
    y2: 222.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_808_10",
    x1: 179.624,
    y1: 54.7097,
    x2: 207.783,
    y2: 54.7097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_808_10",
    x1: 421.456,
    y1: 275.076,
    x2: 539.467,
    y2: 275.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_808_10",
    x1: 550.523,
    y1: 292.152,
    x2: 576.162,
    y2: 292.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_808_10",
    x1: 294.366,
    y1: 244.666,
    x2: 368.813,
    y2: 244.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_808_10",
    x1: 331.595,
    y1: 259.005,
    x2: 368.813,
    y2: 259.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_808_10",
    x1: 294.366,
    y1: 259.005,
    x2: 331.595,
    y2: 259.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_808_10",
    x1: 304.503,
    y1: 291.115,
    x2: 321.061,
    y2: 291.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_808_10",
    x1: 304.503,
    y1: 291.244,
    x2: 321.446,
    y2: 291.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_808_10",
    x1: 341.54,
    y1: 291.115,
    x2: 358.098,
    y2: 291.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_808_10",
    x1: 341.156,
    y1: 291.244,
    x2: 358.098,
    y2: 291.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_808_10",
    x1: 198.404,
    y1: 200.919,
    x2: 216.212,
    y2: 200.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_808_10",
    x1: 209.92,
    y1: 212,
    x2: 243.079,
    y2: 212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_808_10",
    x1: 294.377,
    y1: 233.916,
    x2: 368.813,
    y2: 233.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_808_10",
    x1: 508.679,
    y1: 241.513,
    x2: 522.844,
    y2: 241.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_808_10",
    x1: 500.904,
    y1: 235.765,
    x2: 514.845,
    y2: 235.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_808_10",
    x1: 502.602,
    y1: 214.992,
    x2: 536.284,
    y2: 214.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_808_10",
    x1: 515.773,
    y1: 192.371,
    x2: 547.202,
    y2: 192.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_808_10",
    x1: 528.134,
    y1: 177.112,
    x2: 532.877,
    y2: 177.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_808_10",
    x1: 524.17,
    y1: 168.734,
    x2: 534.19,
    y2: 168.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_808_10",
    x1: 545.236,
    y1: 161.778,
    x2: 557.724,
    y2: 161.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_808_10",
    x1: 485.927,
    y1: 167.217,
    x2: 490.264,
    y2: 167.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_808_10",
    x1: 246.454,
    y1: 320.34,
    x2: 259.957,
    y2: 320.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_808_10",
    x1: 239.532,
    y1: 325.063,
    x2: 253.035,
    y2: 325.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_808_10",
    x1: 215.443,
    y1: 245.243,
    x2: 221.671,
    y2: 245.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_808_10",
    x1: 238.314,
    y1: 231.961,
    x2: 244.285,
    y2: 231.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_808_10",
    x1: 241.615,
    y1: 247.818,
    x2: 256.816,
    y2: 247.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002FE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_808_10",
    x1: 244.488,
    y1: 258.14,
    x2: 250.983,
    y2: 258.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_808_10",
    x1: 240.301,
    y1: 250.179,
    x2: 250.567,
    y2: 250.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_808_10",
    x1: 219.203,
    y1: 273.602,
    x2: 261.399,
    y2: 273.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_808_10",
    x1: 235.729,
    y1: 262.403,
    x2: 241.732,
    y2: 262.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0011BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_808_10",
    x1: 251.688,
    y1: 282.396,
    x2: 261.399,
    y2: 282.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0011BF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls20);
export default __webpack_public_path__ + "static/media/ils_20.08d5270062e96f050922f23edf1bb3e2.svg";
export { ForwardRef as ReactComponent };